export const MODAL_CHANGE = 'MODAL__CHANGE';
export const MODAL_ISOK = 'MODAL_ISOK ';
export const MODAL_RESET = 'MODAL_RESET';
export const MODAL_COMPONENT = 'MODAL_COMPONENT';